import {
  cachedConsolidatedBillingEnabled,
  cachedTeamWorkspacesEnabled,
  remoteConfig,
  remoteConfigState
} from './remoteConfig'

/**
 * Loads remote configuration from the backend /features endpoint
 * and updates the reactive remoteConfig ref.
 *
 * Always sends auth token. Sets remoteConfigState to:
 * - 'authenticated' when loaded successfully
 * - 'error' when load fails
 */
export async function refreshRemoteConfig(): Promise<void> {
  try {
    const { api } = await import('@/scripts/api')
    const response = await api.fetchApi('/features', { cache: 'no-store' })

    if (response.ok) {
      const config = await response.json()
      window.__CONFIG__ = config
      remoteConfig.value = config
      remoteConfigState.value = 'authenticated'
      cachedTeamWorkspacesEnabled.value = Boolean(
        config.team_workspaces_enabled
      )
      cachedConsolidatedBillingEnabled.value = Boolean(
        config.consolidated_billing_enabled
      )
      return
    }

    console.warn('Failed to load remote config:', response.statusText)
    if (response.status === 401 || response.status === 403) {
      window.__CONFIG__ = {}
      remoteConfig.value = {}
      remoteConfigState.value = 'error'
    }
  } catch (error) {
    console.error('Failed to fetch remote config:', error)
    window.__CONFIG__ = {}
    remoteConfig.value = {}
    remoteConfigState.value = 'error'
  }
}
